import React from 'react'
import {observer} from 'mobx-react'
import {Box, Flex, Stack, Text, BaseButton} from '../../vanilla'
import {Link} from '../../components/link'
import {InfoLightIcon} from '../../components/icons'
import {NoAvailableDealsMessageProps} from '../../types/meal-deals'

const NoAvailableDealsMessageContainer = ({
  isExplorer,
  isMaxLimitReached
}: NoAvailableDealsMessageProps) => {
  let heading = isExplorer
    ? "Sorry, Meal Deals aren't available right now"
    : "Sorry, this deal isn't available right now"

  let copy = isExplorer
    ? 'They may be out of stock or no longer available, check back later.'
    : "It may be out of stock or no longer available, but we have plenty more deals we think you'll love."
  if (isMaxLimitReached) {
    heading = "You've reached the limit for this deal"
    copy =
      'You have already claimed the maximum allowed. Keep shopping for more offers or explore more Meal Deals.'
  }

  return (
    <Flex justifyContent="center" paddingY="16px">
      <Box
        bg="white"
        marginX="20px"
        maxWidth={['full', 'half']}
        borderTopLeftRadius="base"
        borderTopRightRadius="base"
      >
        <Stack
          flexDirection={'row'}
          alignItems={'flex-start'}
          paddingX={['10px', '16px']}
          paddingY={['10px', '12px']}
          border="1px"
          borderColor="infoDark"
          borderRadius="base"
          bg="infoLight"
          gap="10px"
        >
          <Box minWidth="24px">
            <InfoLightIcon
              width="24px"
              height="24px"
              boxSize="48px"
              color="infoDark"
              fill="infoDark"
            />
          </Box>
          <Stack flexDirection={'column'} alignItems={'flex-start'}>
            <Text variant="heading1Bold">{heading}</Text>
            <Text variant="text6">{copy}</Text>
          </Stack>
        </Stack>
        <Stack
          paddingX="16px"
          paddingY="20px"
          flexDirection={'column'}
          justifyContent={'center'}
          alignItems={'center'}
          gap="16px"
        >
          <BaseButton as={Link} to="/offers" width="full" size="lg">
            <Text variant="text3Bold">{isExplorer ? 'View Offers' : 'Continue Shopping'}</Text>
          </BaseButton>
          {!isExplorer && (
            <Text
              as={Link}
              variant="text4"
              to="/meal-deals"
              textDecoration="underline"
              color={{default: 'accent3', hover: 'accent3Light'}}
            >
              View More Deals
            </Text>
          )}
        </Stack>
      </Box>
    </Flex>
  )
}

export const NoAvailableDealsMessage = observer(NoAvailableDealsMessageContainer)
